<template>
  <div>
    <p class="font-weight-bolder mb-2">
      ใส่คำตอบ [ระบบจะทำการเช็คคำตอบที่ถูกต้องให้]
    </p>
    <p v-if="!textareaValue" class="no-answer">
      ยังไม่กำหนดคำตอบของคำถาม
    </p>
    <div class="mt-2">
      {{ textareaValue }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  namespaced: true,
  props: ["questionId", "questionIndex", "sectionIndex", "isSubQuestion", "mainQuestionId"],
  data() {
    return {
      token: localStorage.getItem("token"),
      textareaValue: "",
      answer: []
    };
  },
  mounted() {},

  computed: {
    ...mapGetters("ExamBuilder", ["exam", "allAnswer", "hasAnswers"]) ,
  },

  created() {
    this.initTextareaValue(this.questionId);
  },

  methods: {
    ...mapActions("ExamBuilder", [
      "setSolution"
    ]),

    async initTextareaValue(questionId) {
      if (this.hasAnswers[questionId]) {
        this.answer = Array.isArray(this.allAnswer)
          ? this.allAnswer.find(item => item && item.questionId != null && item.questionId === questionId)
          : null;
        this.textareaValue = this.answer.answerText;
        this.setSolution(questionId, this.answer.solution)
      } else {
        this.setSolution(questionId, "")
      }
    },
  },
};
</script>
<style lang="css" scope>
.no-answer {
    color: orange;
    width: 100%;
    padding: 10px;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 5px;
}
.editor-button {
  display: flex;
  justify-content: flex-end;
}
</style>
